import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { MerchantCashflowPage } from './merchant-cashflow';

@NgModule({
  declarations: [
    MerchantCashflowPage,
  ],
  imports: [
    IonicPageModule.forChild(MerchantCashflowPage),
    TranslateModule.forChild()
  ],
})
export class MerchantCashflowPageModule {}



// WEBPACK FOOTER //
// ./src/pages/merchant-cashflow/merchant-cashflow.module.ts